import React from "react";
import ConnectedUseElements from "./ConnectedUseElements";
import ConnectedUseSetAbandonedGiftCookie from "./ConnectedUseSetAbandonedGiftCookie";
import ConnectedUseTrackAbandonedGift from "./ConnectedUseTrackAbandonedGift";

const AbandonedGiftInteractions = () => (
    <>
        <ConnectedUseElements />
        <ConnectedUseSetAbandonedGiftCookie />
        <ConnectedUseTrackAbandonedGift />
    </>
);

export default AbandonedGiftInteractions;
